import React, { useEffect, useState } from 'react';
import ProductHomePageSectionDetailsFields from './ProductHomePageSectionDetailsFields';

function EditProductHomePageSection({ SectionData, sendDataToParent }) {
  const [formData, setFormData] = useState(SectionData || {});

  useEffect(() => {
    setFormData(SectionData || {});
  }, [SectionData]);

  return (
    <ProductHomePageSectionDetailsFields
      formData={formData}
      sendDataToParent={sendDataToParent}
    />
  );
}

export default EditProductHomePageSection;
